/* eslint-disable import/prefer-default-export */
import querystring from 'query-string'
import config from 'config'

export const getCtaUrl = ({ embeddedWidgetQueryParams, showRateTableAsFirstPrequalStep }) => {
  const { widget_id: _widgetId, ...restParams } = querystring.parse(embeddedWidgetQueryParams)
  const base = `${config.credibleRoot}/refinance`
  const embeddedPrequalUrl = `${base}/embedded-prequal/refinancing-goal?${embeddedWidgetQueryParams}`
  const prequalUrl = `${base}/prequal/signup?${querystring.stringify(restParams)}`

  return showRateTableAsFirstPrequalStep ? embeddedPrequalUrl : prequalUrl
}
